// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"bdaa9ae1","133":"8c37e9b5","371":"3f4fe2e5","441":"2d60869b","577":"010c9581"}[chunkId] + ".chunk.js";
};